module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_bice_Min.7704cd6c.svg";